import {Link, useNavigate} from 'react-router-dom';
import '../styles/layout/header.css';
import {useEffect, useState} from 'react';
import {BASE_URL} from '../Config';
import Button from './Button';
import {apiRequest} from "../utils/api";

const UserHeader = () => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userState, setUserState] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleLogin = () => {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                const parsed = JSON.parse(storedUser);
                setIsLoggedIn(true);
                setUserState(parsed.state); // ← 상태 저장 (R, Y 등)
            } else {
                setIsLoggedIn(false);
                setUserState(null);
            }
        };

        handleLogin(); // 첫 진입 시 실행
        window.addEventListener('login', handleLogin); // 커스텀 이벤트로 로그인 반영

        return () => window.removeEventListener('login', handleLogin);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        setUserState(null);
        navigate('/login');
    };

    const deleteUser = async () => {
        try {
            const storedUser = localStorage.getItem('user');
            if (!storedUser) return;

            const {id} = JSON.parse(storedUser);

            const res = await apiRequest('/userDelete', 'POST', {ID: id});

            if (res.success) {
                alert('회원탈퇴가 완료되었습니다.');
                handleLogout();
            } else {
                alert('회원탈퇴에 실패했습니다.');
            }
        } catch (err) {
            console.error('회원탈퇴 오류:', err);
            alert('오류가 발생했습니다.');
        }
    };

    const handleWithdraw = () => {
        const confirmed = window.confirm('정말로 회원탈퇴하시겠습니까?');
        if (confirmed) {
            deleteUser();
        }
    };

    return (
        <header className="header">
            <Link to="/">
                <img
                    src="/assets/images/daedeok-logo.svg"
                    alt="logo"
                    className="header-logo"
                />
            </Link>

            <div className="hamburger" onClick={() => setIsMobileMenuOpen(true)}>
                <img src="/assets/icons/mobile-menu.svg" alt="Mobile Menu"/>
            </div>

            {isMobileMenuOpen && (
                <>
                    <div
                        className="backdrop"
                        onClick={() => setIsMobileMenuOpen(false)}
                    ></div>
                    <div className="mobile-menu">
                        <Link to="/patrolList" onClick={() => setIsMobileMenuOpen(false)}>
                            순찰목록
                        </Link>
                        {isLoggedIn ? (
                            <>
                                <button
                                    onClick={() => {
                                        handleLogout();
                                        setIsMobileMenuOpen(false);
                                    }}
                                >
                                    로그아웃
                                </button>
                                <button
                                    onClick={() => {
                                        handleWithdraw();
                                        setIsMobileMenuOpen(false);
                                    }}
                                    className="withdraw-menu-item"
                                >
                                    회원탈퇴
                                </button>
                            </>
                        ) : (
                            <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
                                로그인
                            </Link>
                        )}
                    </div>

                </>
            )}
        </header>
    );
};

export default UserHeader;
